/**
 * Checkout Form Schemas
 * Zod validation schemas for checkout flow
 */

import { z } from 'zod';

/**
 * Phone number formatting helper
 * Formats phone to (XXX) XXX-XXXX
 */
export const formatPhoneNumber = (value: string): string => {
  const digits = value.replace(/\D/g, '');
  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
};

/**
 * Checkout contact schema
 */
export const checkoutSchema = z.object({
  name: z
    .string()
    .min(2, 'Full name is required')
    .regex(/^[a-zA-Z\s'-]+$/, 'Please enter a valid name'),
  email: z.string().email('Valid email address is required'),
  phone: z
    .string()
    .regex(/^\(\d{3}\) \d{3}-\d{4}$/, 'Valid phone number required (e.g., (555) 123-4567)'),
  companyName: z.string().optional(),
  createPassword: z.string().min(8, 'Password must be at least 8 characters').optional(),
});

export type CheckoutForm = z.infer<typeof checkoutSchema>;
